import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { selectOcurrence } from '../../../../redux/actions/f5-actions/ocurrences-actions';
import ocurrencesActionService from '../../../../services/f5-services/ocurrencesActionService';
import { Box, Button, CircularProgress } from '@material-ui/core';

import VerticalSplitIcon from '@material-ui/icons/VerticalSplit';

import SharedTitle from './SharedTitle';
import SharedDescription from './SharedDescription';
import sweetAlert from '../../../../f5/utils/sweetAlert';

import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    maxHeight: '80vh',
    overflowY: 'auto',
    overflowX: 'hidden',
  },
  buttonRootYes: {
    color: 'white',
    backgroundColor: '#1dad41',
    '&:hover': {
      backgroundColor: '#34c95a',
    },
  },
  buttonRootNo: {
    color: 'white',
    backgroundColor: '#db1414',
    '&:hover': {
      backgroundColor: '#ed3737',
    },
  },
}));

const UngroupOcurrence = ({ ocurrence, closeIt }) => {
  const [loading, setLoading] = useState({ message: '', status: false });

  const classes = useStyles();

  const dispatch = useDispatch();

  const handleSubmit = async () => {
    setLoading({ status: true, message: 'Desagrupando ocorrência...' });

    await ocurrencesActionService.sendUngroupOcurrence(ocurrence.ocorrencia_id);

    dispatch(selectOcurrence(ocurrence.ocorrencia_id));
    setLoading({ status: false, message: '' });
    sweetAlert('success', 'Sucesso', 'Ocorrência desagrupada com sucesso!');
  };

  if (loading.status) {
    return (
      <Box
        className={classes.root}
        height={500}
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center">
        <CircularProgress />
        <Box mt={4} fontWeight={700}>
          {loading.message}
        </Box>
      </Box>
    );
  }

  return (
    <div className={classes.root}>
      <SharedTitle icon={<VerticalSplitIcon />} title="Desagrupar Ocorrência" />
      <SharedDescription
        requester={ocurrence.solicitante.nome}
        date={`${new Date(ocurrence.abertura).toLocaleDateString()} às ${new Date(ocurrence.abertura).toLocaleTimeString()}`}
        service={ocurrence.servico}
        protocol={ocurrence.protocolo}
      />

      <Box my={8} fontWeight={500} fontSize={16} textAlign="center">
        Tem certeza que deseja desagrupar essa ocorrência?
      </Box>
      <Box display="flex" alignItems="center" justifyContent="center">
        <Box mx={8}>
          <Button classes={{ root: classes.buttonRootYes }} onClick={handleSubmit}>
            Sim
          </Button>
        </Box>
        <Box mx={8}>
          <Button classes={{ root: classes.buttonRootNo }} onClick={() => closeIt()}>
            Não
          </Button>
        </Box>
      </Box>
    </div>
  );
};

export default UngroupOcurrence;
